// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * SUREnet documenten-public API
 * OpenAPI spec version: 1
 */
import { useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type { AllowedFileTypesGetAllowedFileTypesParams } from '../model/allowedFileTypesGetAllowedFileTypesParams';

import type { CollectionResultOfDocumentenApplicationServicesFileTypeDto } from '../model/collectionResultOfDocumentenApplicationServicesFileTypeDto';

import { customInstance } from '../../customInstance';
import type { ErrorType } from '../../customInstance';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Haal toegestane bestandtypes op om te uploaden.
 */
export const allowedFileTypesGetAllowedFileTypes = (
  params?: MaybeRef<AllowedFileTypesGetAllowedFileTypesParams>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  params = unref(params);

  return customInstance<CollectionResultOfDocumentenApplicationServicesFileTypeDto>(
    { url: `/api/v1/documenten/allowed-file-types`, method: 'GET', params: unref(params), signal },
    options,
  );
};

export const getAllowedFileTypesGetAllowedFileTypesQueryKey = (
  params?: MaybeRef<AllowedFileTypesGetAllowedFileTypesParams>,
) => {
  return ['api', 'v1', 'documenten', 'allowed-file-types', ...(params ? [params] : [])] as const;
};

export const getAllowedFileTypesGetAllowedFileTypesQueryOptions = <
  TData = Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<AllowedFileTypesGetAllowedFileTypesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getAllowedFileTypesGetAllowedFileTypesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>> = ({
    signal,
  }) => allowedFileTypesGetAllowedFileTypes(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>,
    TError,
    TData
  >;
};

export type AllowedFileTypesGetAllowedFileTypesQueryResult = NonNullable<
  Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>
>;
export type AllowedFileTypesGetAllowedFileTypesQueryError = ErrorType<unknown>;

/**
 * @summary Haal toegestane bestandtypes op om te uploaden.
 */

export function useAllowedFileTypesGetAllowedFileTypes<
  TData = Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>,
  TError = ErrorType<unknown>,
>(
  params?: MaybeRef<AllowedFileTypesGetAllowedFileTypesParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof allowedFileTypesGetAllowedFileTypes>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAllowedFileTypesGetAllowedFileTypesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
